import { Button, Container, Form } from 'react-bootstrap'
import React, { useRef, useState, useEffect } from 'react'
import { Editor } from '@tinymce/tinymce-react';
import { useNavigate } from 'react-router-dom';
import { URL } from '../../Services/Url';
import { useGlobalContext } from '../../context/store';
import { getServiceById } from '../../Services/DataServices';


const EditServicePage = () => {

    // For TinyEditor
    const editorRef: any = useRef();

    //Navigation
    const navigate = useNavigate();

    //Context/Props
    const { token, editId, orgId } = useGlobalContext()

  //service Variables
    const [description, setDescription] = useState("")
    const [title, setTitle] = useState("")
    const [iconId, setIconId] = useState(0);
    
 

    useEffect(() => {

        const loadData = async () => {
        let serviceData = await getServiceById(editId)

            //grabbing obj data and setting to service var
            setTitle(serviceData.title);
            setDescription(serviceData.description)
            setIconId(serviceData.iconId)

        }

        loadData();


    }, [])


// EDITING EXISING SERVICE
    const saveServiceByServiceId = async (title: string, description: string, iconId: number, orgId: number) => {
        await fetch(
            `${URL}/Service/saveService`, {
            method: "Post",
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': "application/json",

            },
            body: JSON.stringify({
                "serviceId": editId,
                "title": title,
                "description": description,
                "iconId": iconId,
                "orgId": orgId,

            })
        }
        );
    };

    const handleCancel = () => {
        navigate('/main');
    }
  
    const handleSubmit = () => {
        saveServiceByServiceId(title, description, iconId, orgId);
        navigate('/main')
    }

    return (
        <>
            <Container>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Title</Form.Label>
                        <Form.Control value={title} onChange={(e) => setTitle(e.target.value)} type="text" />

                    </Form.Group>


                    <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>

                        <Editor
                            tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
                            onInit={(editor) => editorRef.current = editor}
                            value={description}
                            onEditorChange={(newText) => setDescription(newText)}
                            init={{
                                height: 500,
                                menubar: false,
                                plugins: [
                                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap',
                                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                    'insertdatetime', 'media', 'table', 'preview', 'help', 'wordcount'
                                ],
                                toolbar: 'undo redo | blocks | ' +
                                    'bold italic forecolor | alignleft aligncenter ' +
                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                    'removeformat | help',
                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'

                            }}
                        />
                    </Form.Group>
                    <Form.Group className="pt-3">
                        {/* <Button onClick={() => openFileSelector()}>Upload Image </Button> */}
                    </Form.Group>
                </Form>
                <div className="d-flex justify-content-end mb-5">

                    <Button className="mx-3" onClick={handleCancel}>Cancel</Button>
                    <Button onClick={handleSubmit}>Submit</Button>
                </div>
            </Container>

        </>
    )
}

export default EditServicePage
